import gql from 'graphql-tag';

export const updateJobRole = gql`
  mutation updateJobRole($id: String!, $changes: JobRoleDataTableInput) {
    updateJobRole(id: $id, changes: $changes) {
      id
      name
      shiftGroups {
        id
        name
      }
      enabled
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
`;
